jQuery(document).ready(function ($) {
	"use strict";

    function adminListingFilter() {
        $('.listing_filter_form').on('change', function () {
            var form = $('.listing_filter_form');
            var checked_input = form.find('input:checked');
            var checked_input_val = checked_input.val();
            var label = checked_input.closest('label');

            $('.filter-item').removeClass('checked');
            label.addClass('checked');

            $.ajax({
                url: form.data('action'),
                data: form.serialize(),
                type: form.attr('method'), // POST
                beforeSend: function (xhr) {
                    $('.listing_grid--body').addClass('loading');
                },
                success: function (data) {
                    $('.listing_grid--body').html(data); // insert data
                    $('.listing_grid--body').removeClass('loading');
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                }
            });
            
            return false;
        });
    }

    adminListingFilter();
});